(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-subscriptions"]) return;
  try {
    


function removeElems() {
  const elems = document.querySelectorAll('.rc_popup');
  setTimeout(function() {
    for (const e of elems) {
      e.remove();
		console.log('trigger');
    }
  }, 1000);
}

function addElems() {
  setTimeout(function() {
   	$('#rc_radio_options').after('<a href="#" id="subscription-popup__trigger" class="subscription-popup__trigger">Why subscribe?</a>');
	$('#subscription-popup__trigger').click( function() {
		$('#subscription-popup__container').addClass('is-open')
	});
	$('#subscription-popup__close').click( function() {
		$('#subscription-popup__container').removeClass('is-open')
	});
  }, 2000);
}

removeElems()
addElems()


  } catch(e) { console.error(e); }
})();
})();
